/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon16Regular = forwardRef('CheckSquareCutIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.75 4.5c0-.966.784-1.75 1.75-1.75H9a.75.75 0 0 0 0-1.5H4.5A3.25 3.25 0 0 0 1.25 4.5v7a3.25 3.25 0 0 0 3.25 3.25h7a3.25 3.25 0 0 0 3.25-3.25V9a.75.75 0 0 0-1.5 0v2.5a1.75 1.75 0 0 1-1.75 1.75h-7a1.75 1.75 0 0 1-1.75-1.75v-7Z" }),
        React.createElement("path", { d: "M14.405 4.05a.75.75 0 0 0-1.06-1.06L7.979 8.354a.5.5 0 0 1-.708 0L5.386 6.47a.75.75 0 0 0-1.061 1.06l1.886 1.886a2 2 0 0 0 2.828 0l5.366-5.366Z" })));
});
